module.exports = __webpack_public_path__ + "kudos_35.svg?66487dc3f3285d62508487c2338882c6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_35.svg
// module id = 134
// module chunks = 0